// extracted by mini-css-extract-plugin
export default {"mainContainer":"dataDownloadDetails_mainContainer__U4IXm","infoContainer":"dataDownloadDetails_infoContainer__WK+YO","downloadButton":"dataDownloadDetails_downloadButton__ox-k6"};